import { render, staticRenderFns } from "./form-customer.vue?vue&type=template&id=5d86fe9c&scoped=true"
import script from "./form-customer.vue?vue&type=script&lang=js"
export * from "./form-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86fe9c",
  null
  
)

export default component.exports